import { errorHandler } from "./error.service";
import { http,URL } from "./http.service";

/**
 * Send OTP for risk verification (without creating order)
 * @param {string} phone - Customer phone number
 * @param {string} businessUuid - The business UUID
 */
export const sendRiskOtp = async (phone, businessUuid) => {
  try {
    const resp = await http.post(`${URL}/risk-otp/send`, {
      phone,
      businessUuid,
      purpose: "order_verification",
    });
    return resp;
  } catch (error) {
    console.error("Error sending risk OTP:", error);
    errorHandler(error);
    throw error;
  }
};

/**
 * Verify Risk OTP
 * @param {string} sessionId - The OTP session ID
 * @param {string} otp - The 6-digit OTP
 * @param {string} businessUuid - The business UUID
 */
export const verifyRiskOtp = async (sessionId, otp, businessUuid) => {
  try {
    const payload = { sessionId, otp, businessUuid };
    const resp = await http.post(`${ URL}/risk-otp/verify`, payload);
    return resp;
  } catch (error) {
    console.error("Error verifying risk OTP:", error);
    errorHandler(error);
    throw error;
  }
};

/**
 * Resend Risk OTP
 * @param {string} sessionId - The OTP session ID
 * @param {string} businessUuid - The business UUID
 */
export const resendRiskOtp = async (sessionId, businessUuid) => {
  try {
    const resp = await http.post(`${ URL}/risk-otp/resend`, {
      sessionId,
      businessUuid,
    });
    return resp;
  } catch (error) {
    console.error("Error resending risk OTP:", error);
    errorHandler(error);
    throw error;
  }
};

/**
 * Get OTP status (for polling)
 * @param {string} sessionId - The OTP session ID
 * @param {string} businessUuid - The business UUID
 */
export const getRiskOtpStatus = async (sessionId, businessUuid) => {
  try {
    const resp = await http.get(
      `${URL}/risk-otp/status?sessionId=${sessionId}&businessUuid=${businessUuid}`,
    );
    return resp;
  } catch (error) {
    console.error("Error fetching risk OTP status:", error);
    errorHandler(error);
    throw error;
  }
};
